import { useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import Button from 'components/Button/Button';
import { useUpcoming } from 'application/dashboard/upcomings/upcoming.context';

import EditTaskModal from './EditTaskModal/EditTaskModal';
import './AddTask.scoped.scss';

interface Props {
  children?: React.ReactNode;
  showAll?: boolean;
}

const TaskItem: React.FC<Props> = ({ showAll }) => {
  const { addAssignment, getAssignments } = useUpcoming();
  const [addTaskPopover, setAddTaskPopover] = useState(false);
  const addTaskButtonRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  async function callAddAssignment(data) {
    await addAssignment(data);
    // eslint-disable-next-line no-unused-expressions
    showAll ? getAssignments('change', {}) : getAssignments('change', { _eq: showAll });
  }

  return (
    <div>
      <div className="add-task">
        <Button
          onClick={() => setAddTaskPopover(true)}
          round
          style={{
            backgroundColor: 'transparent',
            border: '2px solid #6E7E97',
            color: '#213960',
            margin: '0px 30px',
            padding: '0px 20px',
            fontSize: '15px',
            fontWeight: 600,
            pointerEvents: addTaskPopover ? 'none' : 'initial',
            whiteSpace: 'nowrap',
          }}
        >
          {t('common:add_task')}
        </Button>
      </div>

      <div ref={addTaskButtonRef}>
        <EditTaskModal
          open={addTaskPopover}
          onClose={() => {
            setAddTaskPopover(false);
          }}
          sendData={data => callAddAssignment(data)}
        />
      </div>
    </div>
  );
};

export default TaskItem;
